module.exports = __webpack_public_path__ + "img/reportChicken_7.67d87673.png";